// extracted by mini-css-extract-plugin
export default {"view_all":"contact-card_view_all__zsfT8"};